"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumTypeSwitchWidget = void 0;
var React = require("react");
var PremiumTypeSwitchWidget = /** @class */ (function (_super) {
    __extends(PremiumTypeSwitchWidget, _super);
    function PremiumTypeSwitchWidget(props) {
        return _super.call(this, props) || this;
    }
    PremiumTypeSwitchWidget.prototype.render = function () {
        var _this = this;
        var annualSelected = this.props.interaction.factors.premiumType === "annual";
        return (React.createElement("div", { className: "row premium-type-switch" },
            React.createElement("div", { className: "col-12" },
                React.createElement("div", { className: "float-right tier-premium-type" },
                    React.createElement("div", { className: annualSelected ? "annual selected" : "annual", onClick: function (e) { return _this.switchPremiumType(); } },
                        React.createElement("span", null, "Annual")),
                    React.createElement("div", { className: "p-0 background-color-grey" },
                        React.createElement("div", { className: annualSelected ? "tier-premium-type-input annual" : "tier-premium-type-input monthly", onClick: function (e) { return _this.switchPremiumType(); } },
                            React.createElement("span", null))),
                    React.createElement("div", { className: annualSelected ? "monthly" : "monthly selected", onClick: function (e) { return _this.switchPremiumType(); } },
                        React.createElement("span", null, "Monthly"))))));
    };
    PremiumTypeSwitchWidget.prototype.switchPremiumType = function () {
        var newPremiumType = this.props.interaction.factors.premiumType === "annual" ? "monthly" : "annual";
        this.props.executePremiumChange(newPremiumType);
    };
    return PremiumTypeSwitchWidget;
}(React.Component));
exports.PremiumTypeSwitchWidget = PremiumTypeSwitchWidget;
//# sourceMappingURL=PremiumTypeSwitchWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/PremiumTypeSwitchWidget.js
// module id = 3227
// module chunks = 0